import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails } from 'visa-store';
import * as errorUtils from 'error-message-utility';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i2 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';

class APIFeeCalculation {
    constructor(http) {
        this.http = http;
    }
    getFeeCalculation(visatype, caseType, caseId, superTaskId, taskId) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/fees?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    resetFeeCalculation(visatype, caseType, caseId) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/fees/reset`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    postFeeCalculation(visatype, caseType, caseId, superTaskId, taskId, payload) {
        return this.http.post(`/${visatype}/${caseType}/${caseId}/fees?superTaskId=${superTaskId}&taskId=${taskId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getGCFeeCalculation(taskId, caseId) {
        return this.http.get(`/task/${taskId}/case/${caseId}/fee`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    resetI140FeeCalculation(taskId, caseId) {
        return this.http.get(`/task/${taskId}/case/${caseId}/fee/reset`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
APIFeeCalculation.ɵfac = function APIFeeCalculation_Factory(t) { return new (t || APIFeeCalculation)(i0.ɵɵinject(i1.HttpClient)); };
APIFeeCalculation.ɵprov = i0.ɵɵdefineInjectable({ token: APIFeeCalculation, factory: APIFeeCalculation.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIFeeCalculation, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseFeeCalculationLibraryService {
    constructor(store, toastr, apiService, stepStatusUpdatePayloadCostructionService, appServicesLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.apiService = apiService;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.enableEdit = false;
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
        this.checked = true;
        this.clonedFees = {};
        this.feeTotal = 0;
        this.showMultipleApplicantsFeeStructure = false;
    }
    loadInit() {
        var _a;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.stepDetails = data;
                this.getFeeCalculation();
                this.toggleControlsStatus();
            });
        }
        else {
            this.getFeeCalculation();
        }
    }
    loadAfterViewInit() {
        this.feeCalculationForm.form.valueChanges.pipe(map(() => this.feeCalculationForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    getFeeCalculation() {
        let taskId = this.inputData.taskId ? parseInt(this.inputData.taskId) : this.inputData.caseId;
        if (this.inputData.caseType === "I140") {
            this.apiService.getGCFeeCalculation(this.inputData.superTaskId, this.inputData.caseId).subscribe((response) => {
                if (response && response['data']) {
                    this.feeCalculation = response['data'];
                    this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                }
            });
        }
        else {
            this.apiService.getFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, taskId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response && response['data']) {
                    this.feeCalculation = response['data'];
                    //  console.log("this.feeCalculation",this.feeCalculation);
                    //  this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                    this.feeCalculation.some((item) => this.showMultipleApplicantsFeeStructure = item.hasOwnProperty('feeSectionName')); // true
                    if (this.showMultipleApplicantsFeeStructure) {
                        this.feeCalculation.forEach((singlefee, i) => {
                            var _a;
                            let sectionTotal = ((_a = this.feeCalculation[i]) === null || _a === void 0 ? void 0 : _a.fees).reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                            this.feeCalculation[i]['sectionTotal'] = sectionTotal;
                        });
                        this.feeTotal = this.feeCalculation.reduce((a, { sectionTotal }) => a + parseInt(sectionTotal), 0);
                    }
                    else {
                        this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                    }
                    //   console.log("$$$ fee", this.feeCalculation,this.feeTotal);
                }
            });
        }
    }
    resetFeeCalucation() {
        if (this.inputData.caseType === 'I140') {
            this.apiService.resetI140FeeCalculation(this.inputData.superTaskId, this.inputData.caseId).subscribe((response) => {
                if (response && response['data']) {
                    this.feeCalculation = response['data'];
                    this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                    this.toastr.success(response.message, 'Success');
                }
            });
        }
        else {
            this.apiService.resetFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response && response['data']) {
                    this.feeCalculation = response['data'];
                    this.feeCalculation.some((item) => this.showMultipleApplicantsFeeStructure = item.hasOwnProperty('feeSectionName')); // true
                    if (this.showMultipleApplicantsFeeStructure) {
                        this.feeCalculation.forEach((singlefee, i) => {
                            var _a;
                            let sectionTotal = ((_a = this.feeCalculation[i]) === null || _a === void 0 ? void 0 : _a.fees).reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                            this.feeCalculation[i]['sectionTotal'] = sectionTotal;
                        });
                        this.feeTotal = this.feeCalculation.reduce((a, { sectionTotal }) => a + parseInt(sectionTotal), 0);
                    }
                    else {
                        this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                    }
                    // this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                    this.toastr.success(response.message, 'Success');
                }
            });
        }
    }
    postFeeCalculation() {
        this.apiService.postFeeCalculation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, this.feeCalculation).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.toastr.success(response.message, 'Success');
            this.feeCalculation = response.data;
            this.feeCalculationForm.resetForm();
        });
    }
    onRowEditInit(item) {
        this.clonedFees[item.feeTypeCode] = Object.assign({}, item);
    }
    onRowEditSave(item) {
        var _a;
        if (parseInt(item.applicableFee) > 0) {
            item.isCustomized = 1;
            delete this.clonedFees[item.feeTypeCode];
            if (this.showMultipleApplicantsFeeStructure) {
                let sectionTotal = ((_a = this.feeCalculation[this.selectedFeeDependentIndex]) === null || _a === void 0 ? void 0 : _a.fees).reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
                this.feeCalculation[this.selectedFeeDependentIndex]['sectionTotal'] = sectionTotal;
                this.feeTotal = this.feeCalculation.reduce((a, { sectionTotal }) => a + parseInt(sectionTotal), 0);
                //console.log("this.feeTotal",this.feeTotal);
            }
            else {
                this.feeTotal = this.feeCalculation.reduce((a, { applicableFee }) => a + parseInt(applicableFee), 0);
            }
        }
    }
    onRowEditCancel(item, index) {
        this.feeCalculation[index] = this.clonedFees[item.feeTypeCode];
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    updateControls(status) {
        this.enableEdit = status;
    }
    onTabOpen(e) {
        this.selectedFeeDependentIndex = e.index;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseFeeCalculationLibraryService.ɵfac = function BaseFeeCalculationLibraryService_Factory(t) { return new (t || BaseFeeCalculationLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(APIFeeCalculation), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.AppServicesLibraryService)); };
BaseFeeCalculationLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseFeeCalculationLibraryService, factory: BaseFeeCalculationLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFeeCalculationLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: APIFeeCalculation }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-fee-calculation-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIFeeCalculation, BaseFeeCalculationLibraryService };
//# sourceMappingURL=base-fee-calculation-library.js.map
